// src/pages/customer/BlogDetailPage.jsx
import React, { useState, useEffect } from "react";
import { useContext } from "react";
import AppContext from "../../../contexts/AppContext";
import { useNavigate, useLocation } from "react-router-dom";
import { Container, Row, Col, Button } from "react-bootstrap";
import { FiArrowLeft, FiCalendar, FiUser, FiClock } from "react-icons/fi";
import MyNavbar from "../../../components/general/mynavbar/MyNavbar";
import BlogContentBlock from "../../../subscreens/customer/blog/BlogContentBlock";
import BlogShareSection from "../../../subscreens/customer/blog/BlogShareSection";
import BlogComments from "../../../subscreens/customer/blog/BlogComment";
import BlogCommentForm from "../../../subscreens/customer/blog/BlogCommentForm";
import BlogSidebar from "../../../components/customer/blogsidebar/BlogSidebar";
import { allBlogsData } from "../../../subscreens/customer/blog/BlogData";
import "../../../assets/css/customer/subscreens/blog/BlogDetailPage.css";
import DOMPurify from "dompurify";

const BlogDetailPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const { baseUrlForFiles } = useContext(AppContext);

  useEffect(() => {
    setLoading(true);

    const blogData = location.state?.blogData;

    if (blogData) {
      if (!blogData.content) {
        const fullBlog = allBlogsData.find(
          (b) => b.id === blogData.id || b.slug === blogData.slug,
        );
        if (fullBlog) {
          setBlog(fullBlog);
        } else {
          setBlog(blogData);
        }
      } else {
        setBlog(blogData);
      }
    } else {
      navigate("/blogs");
      return;
    }

    setLoading(false);
    window.scrollTo(0, 0);
  }, [location.state, navigate]);

  const getRelatedBlogs = () => {
    if (!blog) return [];
    return allBlogsData
      .filter((b) => b.id !== blog.id && b.category === blog.category)
      .slice(0, 3);
  };

  if (loading) {
    return (
      <>
        <MyNavbar />
        <div className="text-center py-5" style={{ marginTop: 100 }}>
          <h2>Loading...</h2>
        </div>
      </>
    );
  }

  if (!blog) {
    return (
      <>
        <MyNavbar />
        <div className="text-center py-5" style={{ marginTop: 100 }}>
          <h2>Blog not found</h2>
          <Button
            variant="primary"
            className="mt-4"
            onClick={() => navigate("/blogs")}
          >
            Back to Blogs
          </Button>
        </div>
      </>
    );
  }

  const relatedBlogs = getRelatedBlogs();
  const popularBlogs = allBlogsData.slice(0, 6);

  return (
    <>
      <MyNavbar />
      <div className="blog-detail-bootstrap">
        <Container className="blog-container">
          <Row className="blog-layout g-4">
            {/* Main Content Column */}
            <Col lg={8} xl={9} className="blog-main-col">
              <div className="blog-main-content">
                {/* Back Button & Title Container */}
                <div className="title-with-back">
                  <Button
                    variant="outline-dark"
                    className="blog-back-btn"
                    onClick={() => navigate("/blogs")}
                  >
                    <FiArrowLeft size={20} />
                  </Button>

                  <h1 className="blog-title">{blog.title}</h1>
                </div>

                {/* Featured Image */}
                <div className="blog-featured-image">
                  <img src={`${baseUrlForFiles}/${blog.blogimage}`} alt={blog.title} />

                </div>

                {/* Meta Info */}
                <div className="blog-meta-info">
                  <span className="meta-item">
                    <FiUser size={14} /> {blog.admin?.name ?? "Admin"}
                  </span>
                  <span className="meta-item">
                    <FiCalendar size={14} />{" "}
                    {new Date(blog.created_at).toLocaleDateString()}
                  </span>
                  {/* <span className="meta-item">
                    <FiClock size={14} /> {blog.readTime}
                  </span> */}
                </div>

                {/* Content */}
                <div className="blog-text-content">
                  {blog.content ? (
                    <div
                      dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(blog.content),
                      }}
                    />
                  ) : (
                    <p>No content available</p>
                  )}
                </div>

                {/* Share Section */}
                <BlogShareSection title={blog.title} />

              </div>
            </Col>

            {/* Sidebar Column */}
            <Col lg={4} xl={3} className="blog-sidebar-col d-none d-lg-block">
              <BlogSidebar
                relatedBlogs={relatedBlogs}
                popularBlogs={popularBlogs}
                keywords={blog.keyword ? blog.keyword.split(", ").filter(Boolean) : []}
              />
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default BlogDetailPage;
